import { render, staticRenderFns } from "./addAfter.vue?vue&type=template&id=719d0b6a&"
import script from "./addAfter.vue?vue&type=script&lang=js&"
export * from "./addAfter.vue?vue&type=script&lang=js&"
import style0 from "./addAfter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports